import React, { useState } from 'react'

const TestError = () => {
    const [test, ] = useState("test")
  return (
    <div>
        <button
        onClick={()=>{
            throw new Error("test")
        }}
        >Test</button>
      {test}
    </div>
  )
}

export default TestError